// Core
import React from 'react';
import { useHistory } from 'react-router-dom';

// Custom Components
import QuestionPage from '../../../../../pages/QuestionPage';
import Question from '../../../../../components/primitive/Question';
import QuestionElement from '../../../../../components/complex/QuestionElement';
import ExpandableQuestionDetails from '../../../../../components/complex/ExpandableQuestionDetails';

const Q2 = ({ selection, inner, texts, setSelectionByKey, setInner }) => {
    let history = useHistory();

    const onClickNavigate = direction => () => {
        history.push(direction === 'back' ? '/noShop/q1' : '/noShop/q3');
    };

    const onChange = e => {
        if (selection[e.target.value]) {
            setSelectionByKey('q2', e.target.value, null);
        } else {
            setSelectionByKey('q2', e.target.value, e.target.value);
        }
    };

    const onChangeTextfield = e => {
        setSelectionByKey('q2', 'wymagania', e.target.value);
    };

    const onChangeInner = e => {
        setInner('q2', 'kilkaJęzyków', e.target.value)
    };

    return (
        <QuestionPage onClickLeft={onClickNavigate('back')} onClickRight={onClickNavigate()}>
            <Question
                title={texts.title}
                questionNumber={2}
                questionTotal={14}
            >
                {
                    texts.content.map((field, i) =>
                        <div key={i}>
                            <QuestionElement
                                questionField={field}
                                stateValue={field.type === 'TextArea' ? selection.wymagania : selection[field.value]}
                                onChange={field.type === 'TextArea' ? onChangeTextfield : onChange}
                            />
                            {
                                field.content && field.content.length > 0
                                    ? (
                                        <ExpandableQuestionDetails
                                            fields={field.content}
                                            onChangeInner={onChangeInner}
                                            stateValueInner={inner[field.value]}
                                            isOpen={selection[field.value] === field.value}
                                        />
                                    ) : (
                                        null
                                    )
                            }
                        </div>
                    )
                }
            </Question>
        </QuestionPage>
    );
};

export default Q2;